////////////////////////////////////////////////////////////////////////////////
// Global
////////////////////////////////////////////////////////////////////////////////

let html = $('html');
let body = $('body');
let progressBar = $('progress-bar')

////////////////////////////////////////////////////////////////////////////////
// Initialisers
////////////////////////////////////////////////////////////////////////////////

const listen = new Listen()

// Static Classes
new CustomProperties
new Fixers
new Agent
new Navigation

// Class Instances
const when       = new When({ inview : { class : new InView(), method : 'check' } })
const page       = new Pages()
const inview     = new InView()
const scrollbar  = new Scroll()
const fetcher    = new Fetcher()
const historyAPI = new HistoryAPI()

const slideshow  = new Slideshow($('slide-show'))

// let buttons = $('iteration-test div').iterate({ duration:500, autoPlayDelay:3000}, event => {
// 	console.log(event)
// 	event.currentTarget.addClass('current')
// })

// boxes = $('iteration-test.set-1 div').iterate({
// 	duration   : 2000,
// 	autoPlay   : true,
// 	loop       : 1,
// 	onStart    : (event) => {	event.currentTarget.addClass('current')	},
// 	onEnd      : (event) => { console.log(event); event.currentTarget.removeClass('current') },
// 	onComplete : (event) => { console.log('COMPLETE', event) },
// 	onLoop     : (event) => { console.log('LOOPED', event) }
// })

// buttons.stop()
// buttons.play()
// buttons.pause()
// buttons.update()
// buttons.getCurrent()
// buttons.getNext()
// buttons.getPrevious()
// buttons.next()
// buttons.previous()
// buttons.settings
// buttons.status
// buttons.total
// buttons.elements
// buttons.elements = $('menu-block > button')
// buttons.onStart()
// buttons.onEnd()
// buttons.onComplete()

// console.log('Boxes: ', boxes)

// =============================================================================
// Search
// =============================================================================

const searchComponents = {
	form        : $('#search'),
	input       : $('[type="search"]'),
	suggestions : $('#suggestions')
};

const search = new Search(searchComponents);

// =============================================================================
// Update the scroll position
// =============================================================================

listen.for('scroll-position', () => {
	CustomProperties.set('scroll-position', Scroll.positionY || 0 )
});
